"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedBullTVVideo1Schema = void 0;
exports.RedBullTVVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RedBullTVVideo1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:redbull_tv-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "assetId": {
                    "type": "string",
                    "description": "Asset ID from MIT mediabase asset catalogue (e.g. AA-1UPS7JDND1W12)",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "mbEnvironment": {
                    "type": "string",
                    "description": "On which mediabase environment is the asset available (if not set, production is assumed)",
                    "enum": [
                        "production",
                        "staging"
                    ]
                },
                "videoId": {
                    "type": "string",
                    "description": "Video product ID from MIT aggregation API (e.g. AP-1M8YSM1M51W11)"
                },
                "VIN": {
                    "type": "string",
                    "description": "Video identification number from MIT mediabase asset catalogue (e.g. MI201802070142)",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "videoId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yZWRidWxsX3R2LXZpZGVvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsS0FBSyxFQUFFLHFGQUFxRjtJQUM1RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxpQkFBaUI7SUFDMUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDZDQUE2QzthQUM5QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUscUVBQXFFO29CQUNwRixTQUFTLEVBQUUsbURBQW1EO2lCQUMvRDtnQkFDRCxlQUFlLEVBQUU7b0JBQ2YsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSwyRkFBMkY7b0JBQzFHLE1BQU0sRUFBRTt3QkFDTixZQUFZO3dCQUNaLFNBQVM7cUJBQ1Y7aUJBQ0Y7Z0JBQ0QsU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsbUVBQW1FO2lCQUNuRjtnQkFDRCxLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxzRkFBc0Y7b0JBQ3JHLFNBQVMsRUFBRSxZQUFZO2lCQUN4QjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFNBQVM7YUFDVjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9